import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, PieChart, Pie, Cell } from "recharts";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { retrieveHareKrishnaInventoryData } from "../api/PupilApi"; // Assume this API fetches inventory stats

const Inventory = () => {
  const navigate = useNavigate();
  const [inventoryData, setInventoryData] = useState([]);
  const [categoryStats, setCategoryStats] = useState([]);
  const currentDate = new Date();
const month = String(currentDate.getMonth() + 1).padStart(2, "0"); // Ensure two-digit month
const year = currentDate.getFullYear();
  useEffect(() => {
    retrieveHareKrishnaInventoryData(`orgData${month}${year}@yaazhtech.com`).then((data) => {
      if (data?.data) {
        // Flatten the product list
        const products = data.data.flatMap(category =>
          category.productSubCategoryList.flatMap(subcategory =>
            subcategory.productInfoList.map(product => ({
              productName: product.productName,
              category: category.category,
              stockType: product.stockType,
              sellingPrice: product.sellingPrice
            }))
          )
        );
  
        // Aggregate category stats
        const categoryCounts = data.data.map(category => ({
          category: category.category,
          count: category.productSubCategoryList.reduce(
            (sum, subcategory) => sum + subcategory.productInfoList.length,
            0
          )
        }));
  
        setInventoryData(products);
        setCategoryStats(categoryCounts);
      }
    });
  }, []);
  

  const COLORS = ["#8884d8", "#82ca9d", "#ffc658", "#ff7300", "#d0ed57"];

  return (
    <>
      <Navbar />
      <div className="container mx-auto p-6">
        <h1 className="text-3xl font-bold text-center text-indigo-800 mb-6">Inventory Dashboard</h1>

        <div className="grid grid-cols-1 md-grid-cols-2 gap-6">
          {/* Bar Chart - Inventory by Category */}
          <div className="bg-white p-6 shadow-lg rounded-lg">
            <h2 className="text-xl font-semibold text-gray-700 mb-4">Inventory by Category</h2>
            <BarChart width={500} height={300} data={categoryStats}>
              <XAxis dataKey="category" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Bar dataKey="count" fill="#8884d8" />
            </BarChart>
          </div>

          {/* Pie Chart - Product Distribution */}
          <div className="bg-white p-6 shadow-lg rounded-lg">
            <h2 className="text-xl font-semibold text-gray-700 mb-4">Product Distribution</h2>
            <PieChart width={400} height={300}>
              <Pie
                data={categoryStats}
                cx={200}
                cy={150}
                outerRadius={100}
                fill="#82ca9d"
                dataKey="count"
                label
              >
                {categoryStats?.map((_, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip />
            </PieChart>
          </div>
        </div>

        {/* Product List */}
        <div className="bg-white p-6 mt-6 shadow-lg rounded-lg">
          <h2 className="text-xl font-semibold text-gray-700 mb-4">Recent Products</h2>
          <table className="w-full border-collapse border border-gray-200">
            <thead>
              <tr className="bg-gray-100">
                <th className="border p-2">Product Name</th>
                <th className="border p-2">Category</th>
                <th className="border p-2">Stock</th>
                <th className="border p-2">Selling Price</th>
              </tr>
            </thead>
            <tbody>
              {inventoryData?.slice(0, 5)?.map((product, index) => (
                <tr key={index} className="text-center">
                  <td className="border p-2">{product.productName}</td>
                  <td className="border p-2">{product.category}</td>
                  <td className="border p-2">{product.stockType}</td>
                  <td className="border p-2">${product.sellingPrice}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Navigation Buttons */}
        <div className="flex justify-between mt-6">
          <button
            onClick={() => navigate(-1)}
            className="bg-gray-500 text-white px-6 py-3 rounded-md hover:bg-gray-600 text-lg font-bold"
          >
            Back
          </button>
          <button
            onClick={() => navigate("/inventory/add")}
            className="bg-indigo-600 text-white px-8 py-3 rounded-md hover:bg-indigo-700 text-lg font-bold"
          >
            Add Product
          </button>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Inventory;
